import { render, staticRenderFns } from "./HtmlType.vue?vue&type=template&id=49c7bed6&"
import script from "./HtmlType.vue?vue&type=script&lang=ts&"
export * from "./HtmlType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports